import React from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { sessionCheck } from 'src/actions/user';
import { handleErrorWithDialog } from 'src/util/Errors';
import { TrackingAnalytics } from 'src/analytics/TrackingAnalytics';
import { ScreenRecorder } from 'src/util/ScreenRecorder';
import ColorPicker from 'src/components/shared/ColorPicker';
import POPinLogo from 'src/images/popin-logo-horizontal.svg';
import { notify } from 'react-notify-toast';
import { mediaApi } from 'src/api/MediaApi';
import { themeApi } from 'src/api/ThemeApi';
import './Themes.css';
import _ from 'lodash';
import PayMeModal from 'src/money/PayMeModal';

class Branding extends React.Component {

  state = {
    showPayMeMoney: false,
    isLogoChanged: false,
    logoFile: null,
    logoURL: null,
    textColor: '#FFFFFF',
    bgColor: '#36A4DB',
    chartColor: '#f3c300'
  };

  constructor (props) {
    super(props);
    TrackingAnalytics.mixpanelTrackPageViewed();
  }

  componentDidMount () {
    const { sessionCheck } = this.props;
    sessionCheck(false);

    // Start recording
    ScreenRecorder.record();

    // Scroll to page top on initial page load
    window.scrollTo(0, 0);

    // Grab default theme if available
    themeApi.getDefaultTheme().then((defaultTheme) => {
      const logoURL = _.get(defaultTheme, 'logo_media.photo');
      if (logoURL) {
        this.setState({
          logoURL: logoURL,
        });
      }
      if (defaultTheme.text_color) {
        this.setState({
          textColor: defaultTheme.text_color,
        });
      }
      if (defaultTheme.bg_color) {
        this.setState({
          bgColor: defaultTheme.bg_color
        });
      }
    });
  }

  componentDidUpdate (prevProps) {
    const { userError } = this.props;
    if (userError) {
      handleErrorWithDialog(userError, prevProps.userError,
        'Unable to load your Account, please try again later');
    }
  }

  setComponentRef = ($element) => {
    TrackingAnalytics.listenForActiveUser($element, 'Themes');
  };

  handleTextColorChange = (newColor) => {
    this.setState({
      textColor: newColor.hex
    });
  };

  handleBgColorChange = (newColor) => {
    this.setState({
      bgColor: newColor.hex
    });
  };

  handleChartColorChange = (newColor) => {
    this.setState({
      chartColor: newColor.hex
    });
  };

  handleLogoUpload = (files) => {
    if (!files || files.length < 1) return;
    const logoFile = files[0];
    const logoURL = URL.createObjectURL(logoFile);
    this.setState({
      isLogoChanged: true,
      logoFile: logoFile,
      logoURL: logoURL
    });
  };

  handleSave = () => {
    const { user } = this.props;
    if (!_.get(user, 'plan.features.custom_branding')) {
      this.setState({ showPayMeMoney: true });
      return;
    }

    const theme = {};
    if (this.state.textColor) {
      theme.text_color = this.state.textColor;
    }
    if (this.state.bgColor) {
      theme.bg_color = this.state.bgColor;
    }
    if (this.state.chartColor) {
      theme.chart_color = this.state.chartColor;
    }
    if (this.state.isLogoChanged) {
      mediaApi.uploadMedia(this.state.logoFile).then((logoMedia) => {
        theme.logo_media = logoMedia.id;
        themeApi.upsertDefaultTheme(theme)
          .then((updatedTheme) => {
            notify.show('Custom branding updated successfully', 'success', 1000);
          });
      });
    }
    else {
      themeApi.upsertDefaultTheme(theme)
        .then((updatedTheme) => {
          notify.show('Custom branding updated successfully', 'success', 1000);
        });
    }
  };

  onHideModal = () => {
    this.setState({ showPayMeMoney : false });
  }

  render () {
    const { showPayMeMoney } = this.state;
    const { user } = this.props;
    if (!user) {
      return (
        <div className="container py-3" ref={ this.setComponentRef }>
          <div className="content">Loading...</div>
        </div>
      );
    } else {
      return (
        <div className="container py-3" ref={ this.setComponentRef }>
          <div className="row">
            <div className="col-12 text-left">
              <h1 className="h3">Custom Branding</h1>
              <h2 className="mt-2 mb-4">Customize the look and feel to match your organization's brand</h2>

              <ul className="nav nav-tabs" role="tablist">
                <li className="nav-item">
                  <a aria-controls="home" aria-selected="true" className="nav-link active" data-toggle="tab" href="#liveview" id="liveview-tab" role="tab">Live View</a>
                </li>
              </ul>

              <div className="tab-content">
                <div aria-labelledby="liveview-tab" className="tab-pane fade show active" id="liveview" role="tabpanel">
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-sm-3">

                  <h5 className="mb-1">Sidebar logo</h5>
                  <Dropzone accept="image/*" onDrop={this.handleLogoUpload}>
                    {({getRootProps, getInputProps}) => (
                      <section>
                        <div {...getRootProps({className: 'dropzone'})}>
                          <input {...getInputProps()} />
                          <p><i className="material-icons">cloud_upload</i> Customize logo</p>
                        </div>
                      </section>
                    )}
                  </Dropzone>

                  <h6 className="mt-3 mb-1">Sidebar Text</h6>
                  <ColorPicker color={ this.state.textColor } onChanged={ this.handleTextColorChange } />

                  <h6 className="mt-3 mb-1">Sidebar Background</h6>
                  <ColorPicker color={ this.state.bgColor } onChanged={ this.handleBgColorChange } />

                  {/* <h6 className="mt-3 mb-1">Chart Color</h6>
                  <ColorPicker color={ this.state.chartColor } onChanged={ this.handleChartColorChange } /> */}

                  <button type="button" className="btn btn-primary mt-4" onClick={ this.handleSave }>Save</button>

                </div>

                <div className="col-sm-9">
                  <h3 className="h4">Preview</h3>

                  <div className="row border" style={ { height: 500 } }>
                    <div className="col-3 border-right p-4 text-center" style={ { color: this.state.textColor, backgroundColor: this.state.bgColor } }>
                      <img src={ this.state.logoURL || POPinLogo } className="mb-4 pb-4" alt="Logo" width="120" />

                      <div className="h3 mt-4 pt-4" style={ { color: this.state.textColor } }>
                        Join at<br/>
                        <b style={ { color: this.state.textColor } }>popin.live</b><br/>
                        and enter code<br/>
                        <b style={ { color: this.state.textColor } }>p0p1n</b>
                      </div>
                    </div>
                    <div className="col-9 p-4 no-gutters text-center">
                      <h3 className="h3">Where should we go for lunch tomorrow?</h3>
                        <div className="chart">
                          <div className="item">
                            <div className="row">
                              <div className="label">Sushi</div>
                            </div>
                            <div className="row chartProgress">
                              <div className="bar" style={ { backgroundColor: this.state.chartColor, width: 300 } }></div>
                              <div className="pct">60%</div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="row">
                              <div className="label">Burger</div>
                            </div>
                            <div className="row chartProgress">
                              <div className="bar" style={ { backgroundColor: this.state.chartColor, width: 150 } }></div>
                              <div className="pct">30%</div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="row">
                              <div className="label">Pizza</div>
                            </div>
                            <div className="row chartProgress">
                              <div className="bar" style={ { backgroundColor: this.state.chartColor, width: 30 } }></div>
                              <div className="pct">7%</div>
                            </div>
                          </div>

                          <div className="item">
                            <div className="row">
                              <div className="label">Salad</div>
                            </div>
                            <div className="row chartProgress">
                              <div className="bar" style={ { backgroundColor: this.state.chartColor, width: 17 } }></div>
                              <div className="pct">3%</div>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        { !!showPayMeMoney && (
          <PayMeModal
            user={ user }
            upsell="Upgrade to the Business plan to use customized Branding"
            openedFrom="Custom Branding Upsell"
            onHidden={ this.onHideModal } />
        ) }

        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user.user,
    userError: state.user.error
  };
};

export default connect(mapStateToProps, { sessionCheck })(Branding);
